module.exports = __webpack_public_path__ + "static/media/happy.cfa6017e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/emoji/happy.png
// module id = 33
// module chunks = 0